import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { ApiContainer } from "../utils/api";
import {
  LOADING_CHANGE,
  ON_FLAG_CHANGE,
  ON_FORM_CHANGE,
  SET_API_DATA,
} from "../redux/constants";
import { clearFormData, toggleModelShow } from "../shared/CustomFunc";
import { showToast } from "../utils/toastService";

const documentsContainer = () => {
  const { api } = ApiContainer();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const documentResult = useSelector((state) => state.api.documentResult);
  const refetchDocumnet = useSelector(
    (state) => state.app.flags?.refetchDocumnet
  );
  const modelState = useSelector((state) => state?.modelStates);
  const [uploadedBy, setUploadedBy] = useState("all");
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [updatedName, setUpdatedName] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [deleteRow, setDeleteRow] = useState(null);
  const [downloadLoading, setDownloadLoading] = useState({});

  const documentLoader = useSelector(
    (state) => state.api?.loader?.documentResult
  );

  const getDocumnet = async () => {
    const response = await api({
      method: "GET",
      endPoint: `document?${
        uploadedBy ? `filter_by=${uploadedBy === "all" ? "" : uploadedBy}` : ""
      }`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: true,
      parent: "documentResult",
    });

    if (response?.status) {
      dispatch({
        type: SET_API_DATA,
        payload: {
          documentResult: response.data,
        },
      });
    } else {
      dispatch({
        type: SET_API_DATA,
        payload: {
          documentResult: [],
        },
      });
    }
  };

  useEffect(() => {
    if (refetchDocumnet) {
      getDocumnet();
      dispatch({
        type: ON_FLAG_CHANGE,
        payload: { refetchDocumnet: false },
      });
    }
  }, [refetchDocumnet]);

  const handleDocumentDownload = async (id) => {
    setDownloadLoading((prev) => ({ ...prev, [id]: true }));
    const response = await api({
      method: "GET",
      endPoint: `document/${id}`,
      showToastMessage: false,
      urlencoded: false,
      needLoader: false,
    });

    if (response?.status && response?.data) {
      const fileName = "document.pdf";
      const link = document.createElement("a");
      link.href = response?.data;
      link.download = fileName;
      link.click();
      setDownloadLoading((prev) => ({ ...prev, [id]: false }));
    }

    if (response?.error === "Document not found") {
      showToast("Document not found", "error");
      setDownloadLoading((prev) => ({ ...prev, [id]: false }));
    }
  };

  const handleDocumentDelete = async () => {
    const data = await api({
      method: "DELETE",
      endPoint: `document/${deleteRow}`,
      showToastMessage: true,
      urlencoded: false,
      parent: "documentResult",
      needLoader: true,
    });
    if (data.status) {
      setShowDialog(false);
      getDocumnet();
    }
  };

  const handleDocumentUpdate = (doc) => {
    setSelectedDocument(doc);
    setUpdatedName(doc?.name || "");
    dispatch(toggleModelShow("updateDocumentName"));
  };

  const handleUpdateSubmit = async () => {
    if (!updatedName.trim()) return;

    if (selectedDocument?.id) {
      const data = await api({
        method: "PUT",
        endPoint: `document/${selectedDocument?.id}`,
        data: { name: updatedName },
        showToastMessage: true,
        urlencoded: false,
        needLoader: true,
        parent: "documentResult",
      });

      if (data?.status) {
        dispatch(toggleModelShow("updateDocumentName"));
        getDocumnet();
      }
    }
  };

  const onDeleteClick = (row) => {
    setDeleteRow(row);
    setShowDialog(!showDialog);
  };

  useEffect(() => {
    if (uploadedBy) {
      getDocumnet();
    }
  }, [uploadedBy]);

  useEffect(() => {
    getDocumnet();
  }, []);

  return {
    documentResult,
    documentLoader,
    handleDocumentDownload,
    dispatch,
    modelState,
    handleDocumentDelete,
    uploadedBy,
    setUploadedBy,
    handleDocumentUpdate,
    updatedName,
    setUpdatedName,
    handleUpdateSubmit,
    onDeleteClick,
    showDialog,
    downloadLoading,
  };
};

export default documentsContainer;
